export class Assign {
    id: number;
    lang: string;
    course: number;
    employee: number;
    token: string;
    sent: Date;
}